export default "__VITE_ASSET__DjKnoM12__"